import type * as core from '../../../../../../../core'

export const query: core.mosaic.Widget.Query = {
  selection: {
    '{}': {
      name: 'Degree of Change by Workstream',
      type: 'charts',
      content: {
        '{}': {
          data: {
            '[]': [
              {
                '{}': {
                  name: 'Degree of Change',
                  values: {
                    '[]': [
                      {
                        '{}': {
                          name: 'High',
                          points: {
                            '[]': [
                              {
                                '{}': {
                                  x: 'Absence',
                                  y: {
                                    '#': {
                                      '@': 'highAbsence',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Academic Staffing',
                                  y: {
                                    '#': {
                                      '@': 'highAcademicStaffing',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Adaptive',
                                  y: {
                                    '#': {
                                      '@': 'highAdaptive',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Banking & Setttlement',
                                  y: {
                                    '#': {
                                      '@': 'highBankingAndSetttlement',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Benefits',
                                  y: {
                                    '#': {
                                      '@': 'highBenefits',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Business Assets',
                                  y: {
                                    '#': {
                                      '@': 'highBusinessAssets',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Compensation',
                                  y: {
                                    '#': {
                                      '@': 'highCompensation',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Core Financials/FDM',
                                  y: {
                                    '#': {
                                      '@': 'highCoreFinancialsFdm',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Cross-Functional',
                                  y: {
                                    '#': {
                                      '@': 'highCrossFunctional',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Customer Accounts',
                                  y: {
                                    '#': {
                                      '@': 'highCustomerAccounts',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Data',
                                  y: {
                                    '#': {
                                      '@': 'highData',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Effort Reporting',
                                  y: {
                                    '#': {
                                      '@': 'highEffortReporting',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Financial Accounting',
                                  y: {
                                    '#': {
                                      '@': 'highFinancialAccounting',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'General',
                                  y: {
                                    '#': {
                                      '@': 'highGeneral',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Grants',
                                  y: {
                                    '#': {
                                      '@': 'highGrants',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'HCM Core',
                                  y: {
                                    '#': {
                                      '@': 'highHcmCore',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Integrations',
                                  y: {
                                    '#': {
                                      '@': 'highIntegrations',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Inventory Management',
                                  y: {
                                    '#': {
                                      '@': 'highInventoryManagement',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Learning',
                                  y: {
                                    '#': {
                                      '@': 'highLearning',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Payroll',
                                  y: {
                                    '#': {
                                      '@': 'highPayroll',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Payroll Accounting',
                                  y: {
                                    '#': {
                                      '@': 'highPayrollAccounting',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Procurement',
                                  y: {
                                    '#': {
                                      '@': 'highProcurement',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Recruiting',
                                  y: {
                                    '#': {
                                      '@': 'highRecruiting',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Reporting',
                                  y: {
                                    '#': {
                                      '@': 'highReporting',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Supplier Accounts',
                                  y: {
                                    '#': {
                                      '@': 'highSupplierAccounts',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Talent',
                                  y: {
                                    '#': {
                                      '@': 'highTalent',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Time Tracking',
                                  y: {
                                    '#': {
                                      '@': 'highTimeTracking',
                                    },
                                  },
                                },
                              },
                            ],
                          },
                        },
                      },
                      {
                        '{}': {
                          name: 'Medium',
                          points: {
                            '[]': [
                              {
                                '{}': {
                                  x: 'Absence',
                                  y: {
                                    '#': {
                                      '@': 'mediumAbsence',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Academic Staffing',
                                  y: {
                                    '#': {
                                      '@': 'mediumAcademicStaffing',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Adaptive',
                                  y: {
                                    '#': {
                                      '@': 'mediumAdaptive',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Banking & Setttlement',
                                  y: {
                                    '#': {
                                      '@': 'mediumBankingAndSetttlement',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Benefits',
                                  y: {
                                    '#': {
                                      '@': 'mediumBenefits',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Business Assets',
                                  y: {
                                    '#': {
                                      '@': 'mediumBusinessAssets',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Compensation',
                                  y: {
                                    '#': {
                                      '@': 'mediumCompensation',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Core Financials/FDM',
                                  y: {
                                    '#': {
                                      '@': 'mediumCoreFinancialsFdm',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Cross-Functional',
                                  y: {
                                    '#': {
                                      '@': 'mediumCrossFunctional',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Customer Accounts',
                                  y: {
                                    '#': {
                                      '@': 'mediumCustomerAccounts',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Data',
                                  y: {
                                    '#': {
                                      '@': 'mediumData',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Effort Reporting',
                                  y: {
                                    '#': {
                                      '@': 'mediumEffortReporting',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Financial Accounting',
                                  y: {
                                    '#': {
                                      '@': 'mediumFinancialAccounting',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'General',
                                  y: {
                                    '#': {
                                      '@': 'mediumGeneral',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Grants',
                                  y: {
                                    '#': {
                                      '@': 'mediumGrants',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'HCM Core',
                                  y: {
                                    '#': {
                                      '@': 'mediumHcmCore',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Integrations',
                                  y: {
                                    '#': {
                                      '@': 'mediumIntegrations',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Inventory Management',
                                  y: {
                                    '#': {
                                      '@': 'mediumInventoryManagement',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Learning',
                                  y: {
                                    '#': {
                                      '@': 'mediumLearning',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Payroll',
                                  y: {
                                    '#': {
                                      '@': 'mediumPayroll',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Payroll Accounting',
                                  y: {
                                    '#': {
                                      '@': 'mediumPayrollAccounting',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Procurement',
                                  y: {
                                    '#': {
                                      '@': 'mediumProcurement',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Recruiting',
                                  y: {
                                    '#': {
                                      '@': 'mediumRecruiting',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Reporting',
                                  y: {
                                    '#': {
                                      '@': 'mediumReporting',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Supplier Accounts',
                                  y: {
                                    '#': {
                                      '@': 'mediumSupplierAccounts',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Talent',
                                  y: {
                                    '#': {
                                      '@': 'mediumTalent',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Time Tracking',
                                  y: {
                                    '#': {
                                      '@': 'mediumTimeTracking',
                                    },
                                  },
                                },
                              },
                            ],
                          },
                        },
                      },
                      {
                        '{}': {
                          name: 'Low',
                          points: {
                            '[]': [
                              {
                                '{}': {
                                  x: 'Absence',
                                  y: {
                                    '#': {
                                      '@': 'lowAbsence',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Academic Staffing',
                                  y: {
                                    '#': {
                                      '@': 'lowAcademicStaffing',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Adaptive',
                                  y: {
                                    '#': {
                                      '@': 'lowAdaptive',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Banking & Setttlement',
                                  y: {
                                    '#': {
                                      '@': 'lowBankingAndSetttlement',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Benefits',
                                  y: {
                                    '#': {
                                      '@': 'lowBenefits',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Business Assets',
                                  y: {
                                    '#': {
                                      '@': 'lowBusinessAssets',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Compensation',
                                  y: {
                                    '#': {
                                      '@': 'lowCompensation',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Core Financials/FDM',
                                  y: {
                                    '#': {
                                      '@': 'lowCoreFinancialsFdm',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Cross-Functional',
                                  y: {
                                    '#': {
                                      '@': 'lowCrossFunctional',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Customer Accounts',
                                  y: {
                                    '#': {
                                      '@': 'lowCustomerAccounts',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Data',
                                  y: {
                                    '#': {
                                      '@': 'lowData',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Effort Reporting',
                                  y: {
                                    '#': {
                                      '@': 'lowEffortReporting',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Financial Accounting',
                                  y: {
                                    '#': {
                                      '@': 'lowFinancialAccounting',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'General',
                                  y: {
                                    '#': {
                                      '@': 'lowGeneral',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Grants',
                                  y: {
                                    '#': {
                                      '@': 'lowGrants',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'HCM Core',
                                  y: {
                                    '#': {
                                      '@': 'lowHcmCore',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Integrations',
                                  y: {
                                    '#': {
                                      '@': 'lowIntegrations',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Inventory Management',
                                  y: {
                                    '#': {
                                      '@': 'lowInventoryManagement',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Learning',
                                  y: {
                                    '#': {
                                      '@': 'lowLearning',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Payroll',
                                  y: {
                                    '#': {
                                      '@': 'lowPayroll',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Payroll Accounting',
                                  y: {
                                    '#': {
                                      '@': 'lowPayrollAccounting',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Procurement',
                                  y: {
                                    '#': {
                                      '@': 'lowProcurement',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Recruiting',
                                  y: {
                                    '#': {
                                      '@': 'lowRecruiting',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Reporting',
                                  y: {
                                    '#': {
                                      '@': 'lowReporting',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Supplier Accounts',
                                  y: {
                                    '#': {
                                      '@': 'lowSupplierAccounts',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Talent',
                                  y: {
                                    '#': {
                                      '@': 'lowTalent',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Time Tracking',
                                  y: {
                                    '#': {
                                      '@': 'lowTimeTracking',
                                    },
                                  },
                                },
                              },
                            ],
                          },
                        },
                      },
                    ],
                  },
                  xLabel: 'Workstream',
                  yLabel: 'Count',
                },
              },
            ],
          },
          type: 'bar.stacked',
        },
      },
    },
  },
  subqueries: {
    highAbsence: {
      filter: {
        and: [
          {
            in: [
              'Absence',
              {
                '??': [
                  {
                    '@.': '!workstream',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!degree_of_change',
              },
              'High',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    highAcademicStaffing: {
      filter: {
        and: [
          {
            in: [
              'Academic Staffing',
              {
                '??': [
                  {
                    '@.': '!workstream',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!degree_of_change',
              },
              'High',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    highAdaptive: {
      filter: {
        and: [
          {
            in: [
              'Adaptive',
              {
                '??': [
                  {
                    '@.': '!workstream',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!degree_of_change',
              },
              'High',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    highBankingAndSetttlement: {
      filter: {
        and: [
          {
            in: [
              'Banking & Setttlement',
              {
                '??': [
                  {
                    '@.': '!workstream',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!degree_of_change',
              },
              'High',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    highBenefits: {
      filter: {
        and: [
          {
            in: [
              'Benefits',
              {
                '??': [
                  {
                    '@.': '!workstream',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!degree_of_change',
              },
              'High',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    highBusinessAssets: {
      filter: {
        and: [
          {
            in: [
              'Business Assets',
              {
                '??': [
                  {
                    '@.': '!workstream',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!degree_of_change',
              },
              'High',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    highCompensation: {
      filter: {
        and: [
          {
            in: [
              'Compensation',
              {
                '??': [
                  {
                    '@.': '!workstream',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!degree_of_change',
              },
              'High',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    highCoreFinancialsFdm: {
      filter: {
        and: [
          {
            in: [
              'Core Financials/FDM',
              {
                '??': [
                  {
                    '@.': '!workstream',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!degree_of_change',
              },
              'High',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    highCrossFunctional: {
      filter: {
        and: [
          {
            in: [
              'Cross-Functional',
              {
                '??': [
                  {
                    '@.': '!workstream',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!degree_of_change',
              },
              'High',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    highCustomerAccounts: {
      filter: {
        and: [
          {
            in: [
              'Customer Accounts',
              {
                '??': [
                  {
                    '@.': '!workstream',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!degree_of_change',
              },
              'High',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    highData: {
      filter: {
        and: [
          {
            in: [
              'Data',
              {
                '??': [
                  {
                    '@.': '!workstream',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!degree_of_change',
              },
              'High',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    highEffortReporting: {
      filter: {
        and: [
          {
            in: [
              'Effort Reporting',
              {
                '??': [
                  {
                    '@.': '!workstream',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!degree_of_change',
              },
              'High',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    highFinancialAccounting: {
      filter: {
        and: [
          {
            in: [
              'Financial Accounting',
              {
                '??': [
                  {
                    '@.': '!workstream',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!degree_of_change',
              },
              'High',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    highGeneral: {
      filter: {
        and: [
          {
            in: [
              'General',
              {
                '??': [
                  {
                    '@.': '!workstream',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!degree_of_change',
              },
              'High',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    highGrants: {
      filter: {
        and: [
          {
            in: [
              'Grants',
              {
                '??': [
                  {
                    '@.': '!workstream',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!degree_of_change',
              },
              'High',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    highHcmCore: {
      filter: {
        and: [
          {
            in: [
              'HCM Core',
              {
                '??': [
                  {
                    '@.': '!workstream',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!degree_of_change',
              },
              'High',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    highIntegrations: {
      filter: {
        and: [
          {
            in: [
              'Integrations',
              {
                '??': [
                  {
                    '@.': '!workstream',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!degree_of_change',
              },
              'High',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    highInventoryManagement: {
      filter: {
        and: [
          {
            in: [
              'Inventory Management',
              {
                '??': [
                  {
                    '@.': '!workstream',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!degree_of_change',
              },
              'High',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    highLearning: {
      filter: {
        and: [
          {
            in: [
              'Learning',
              {
                '??': [
                  {
                    '@.': '!workstream',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!degree_of_change',
              },
              'High',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    highPayroll: {
      filter: {
        and: [
          {
            in: [
              'Payroll',
              {
                '??': [
                  {
                    '@.': '!workstream',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!degree_of_change',
              },
              'High',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    highPayrollAccounting: {
      filter: {
        and: [
          {
            in: [
              'Payroll Accounting',
              {
                '??': [
                  {
                    '@.': '!workstream',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!degree_of_change',
              },
              'High',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    highProcurement: {
      filter: {
        and: [
          {
            in: [
              'Procurement',
              {
                '??': [
                  {
                    '@.': '!workstream',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!degree_of_change',
              },
              'High',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    highRecruiting: {
      filter: {
        and: [
          {
            in: [
              'Recruiting',
              {
                '??': [
                  {
                    '@.': '!workstream',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!degree_of_change',
              },
              'High',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    highReporting: {
      filter: {
        and: [
          {
            in: [
              'Reporting',
              {
                '??': [
                  {
                    '@.': '!workstream',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!degree_of_change',
              },
              'High',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    highSupplierAccounts: {
      filter: {
        and: [
          {
            in: [
              'Supplier Accounts',
              {
                '??': [
                  {
                    '@.': '!workstream',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!degree_of_change',
              },
              'High',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    highTalent: {
      filter: {
        and: [
          {
            in: [
              'Talent',
              {
                '??': [
                  {
                    '@.': '!workstream',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!degree_of_change',
              },
              'High',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    highTimeTracking: {
      filter: {
        and: [
          {
            in: [
              'Time Tracking',
              {
                '??': [
                  {
                    '@.': '!workstream',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!degree_of_change',
              },
              'High',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    mediumAbsence: {
      filter: {
        and: [
          {
            in: [
              'Absence',
              {
                '??': [
                  {
                    '@.': '!workstream',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!degree_of_change',
              },
              'Medium',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    mediumAcademicStaffing: {
      filter: {
        and: [
          {
            in: [
              'Academic Staffing',
              {
                '??': [
                  {
                    '@.': '!workstream',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!degree_of_change',
              },
              'Medium',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    mediumAdaptive: {
      filter: {
        and: [
          {
            in: [
              'Adaptive',
              {
                '??': [
                  {
                    '@.': '!workstream',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!degree_of_change',
              },
              'Medium',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    mediumBankingAndSetttlement: {
      filter: {
        and: [
          {
            in: [
              'Banking & Setttlement',
              {
                '??': [
                  {
                    '@.': '!workstream',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!degree_of_change',
              },
              'Medium',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    mediumBenefits: {
      filter: {
        and: [
          {
            in: [
              'Benefits',
              {
                '??': [
                  {
                    '@.': '!workstream',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!degree_of_change',
              },
              'Medium',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    mediumBusinessAssets: {
      filter: {
        and: [
          {
            in: [
              'Business Assets',
              {
                '??': [
                  {
                    '@.': '!workstream',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!degree_of_change',
              },
              'Medium',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    mediumCompensation: {
      filter: {
        and: [
          {
            in: [
              'Compensation',
              {
                '??': [
                  {
                    '@.': '!workstream',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!degree_of_change',
              },
              'Medium',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    mediumCoreFinancialsFdm: {
      filter: {
        and: [
          {
            in: [
              'Core Financials/FDM',
              {
                '??': [
                  {
                    '@.': '!workstream',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!degree_of_change',
              },
              'Medium',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    mediumCrossFunctional: {
      filter: {
        and: [
          {
            in: [
              'Cross-Functional',
              {
                '??': [
                  {
                    '@.': '!workstream',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!degree_of_change',
              },
              'Medium',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    mediumCustomerAccounts: {
      filter: {
        and: [
          {
            in: [
              'Customer Accounts',
              {
                '??': [
                  {
                    '@.': '!workstream',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!degree_of_change',
              },
              'Medium',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    mediumData: {
      filter: {
        and: [
          {
            in: [
              'Data',
              {
                '??': [
                  {
                    '@.': '!workstream',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!degree_of_change',
              },
              'Medium',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    mediumEffortReporting: {
      filter: {
        and: [
          {
            in: [
              'Effort Reporting',
              {
                '??': [
                  {
                    '@.': '!workstream',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!degree_of_change',
              },
              'Medium',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    mediumFinancialAccounting: {
      filter: {
        and: [
          {
            in: [
              'Financial Accounting',
              {
                '??': [
                  {
                    '@.': '!workstream',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!degree_of_change',
              },
              'Medium',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    mediumGeneral: {
      filter: {
        and: [
          {
            in: [
              'General',
              {
                '??': [
                  {
                    '@.': '!workstream',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!degree_of_change',
              },
              'Medium',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    mediumGrants: {
      filter: {
        and: [
          {
            in: [
              'Grants',
              {
                '??': [
                  {
                    '@.': '!workstream',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!degree_of_change',
              },
              'Medium',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    mediumHcmCore: {
      filter: {
        and: [
          {
            in: [
              'HCM Core',
              {
                '??': [
                  {
                    '@.': '!workstream',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!degree_of_change',
              },
              'Medium',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    mediumIntegrations: {
      filter: {
        and: [
          {
            in: [
              'Integrations',
              {
                '??': [
                  {
                    '@.': '!workstream',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!degree_of_change',
              },
              'Medium',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    mediumInventoryManagement: {
      filter: {
        and: [
          {
            in: [
              'Inventory Management',
              {
                '??': [
                  {
                    '@.': '!workstream',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!degree_of_change',
              },
              'Medium',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    mediumLearning: {
      filter: {
        and: [
          {
            in: [
              'Learning',
              {
                '??': [
                  {
                    '@.': '!workstream',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!degree_of_change',
              },
              'Medium',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    mediumPayroll: {
      filter: {
        and: [
          {
            in: [
              'Payroll',
              {
                '??': [
                  {
                    '@.': '!workstream',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!degree_of_change',
              },
              'Medium',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    mediumPayrollAccounting: {
      filter: {
        and: [
          {
            in: [
              'Payroll Accounting',
              {
                '??': [
                  {
                    '@.': '!workstream',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!degree_of_change',
              },
              'Medium',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    mediumProcurement: {
      filter: {
        and: [
          {
            in: [
              'Procurement',
              {
                '??': [
                  {
                    '@.': '!workstream',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!degree_of_change',
              },
              'Medium',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    mediumRecruiting: {
      filter: {
        and: [
          {
            in: [
              'Recruiting',
              {
                '??': [
                  {
                    '@.': '!workstream',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!degree_of_change',
              },
              'Medium',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    mediumReporting: {
      filter: {
        and: [
          {
            in: [
              'Reporting',
              {
                '??': [
                  {
                    '@.': '!workstream',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!degree_of_change',
              },
              'Medium',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    mediumSupplierAccounts: {
      filter: {
        and: [
          {
            in: [
              'Supplier Accounts',
              {
                '??': [
                  {
                    '@.': '!workstream',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!degree_of_change',
              },
              'Medium',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    mediumTalent: {
      filter: {
        and: [
          {
            in: [
              'Talent',
              {
                '??': [
                  {
                    '@.': '!workstream',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!degree_of_change',
              },
              'Medium',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    mediumTimeTracking: {
      filter: {
        and: [
          {
            in: [
              'Time Tracking',
              {
                '??': [
                  {
                    '@.': '!workstream',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!degree_of_change',
              },
              'Medium',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    lowAbsence: {
      filter: {
        and: [
          {
            in: [
              'Absence',
              {
                '??': [
                  {
                    '@.': '!workstream',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!degree_of_change',
              },
              'Low',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    lowAcademicStaffing: {
      filter: {
        and: [
          {
            in: [
              'Academic Staffing',
              {
                '??': [
                  {
                    '@.': '!workstream',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!degree_of_change',
              },
              'Low',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    lowAdaptive: {
      filter: {
        and: [
          {
            in: [
              'Adaptive',
              {
                '??': [
                  {
                    '@.': '!workstream',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!degree_of_change',
              },
              'Low',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    lowBankingAndSetttlement: {
      filter: {
        and: [
          {
            in: [
              'Banking & Setttlement',
              {
                '??': [
                  {
                    '@.': '!workstream',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!degree_of_change',
              },
              'Low',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    lowBenefits: {
      filter: {
        and: [
          {
            in: [
              'Benefits',
              {
                '??': [
                  {
                    '@.': '!workstream',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!degree_of_change',
              },
              'Low',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    lowBusinessAssets: {
      filter: {
        and: [
          {
            in: [
              'Business Assets',
              {
                '??': [
                  {
                    '@.': '!workstream',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!degree_of_change',
              },
              'Low',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    lowCompensation: {
      filter: {
        and: [
          {
            in: [
              'Compensation',
              {
                '??': [
                  {
                    '@.': '!workstream',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!degree_of_change',
              },
              'Low',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    lowCoreFinancialsFdm: {
      filter: {
        and: [
          {
            in: [
              'Core Financials/FDM',
              {
                '??': [
                  {
                    '@.': '!workstream',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!degree_of_change',
              },
              'Low',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    lowCrossFunctional: {
      filter: {
        and: [
          {
            in: [
              'Cross-Functional',
              {
                '??': [
                  {
                    '@.': '!workstream',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!degree_of_change',
              },
              'Low',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    lowCustomerAccounts: {
      filter: {
        and: [
          {
            in: [
              'Customer Accounts',
              {
                '??': [
                  {
                    '@.': '!workstream',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!degree_of_change',
              },
              'Low',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    lowData: {
      filter: {
        and: [
          {
            in: [
              'Data',
              {
                '??': [
                  {
                    '@.': '!workstream',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!degree_of_change',
              },
              'Low',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    lowEffortReporting: {
      filter: {
        and: [
          {
            in: [
              'Effort Reporting',
              {
                '??': [
                  {
                    '@.': '!workstream',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!degree_of_change',
              },
              'Low',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    lowFinancialAccounting: {
      filter: {
        and: [
          {
            in: [
              'Financial Accounting',
              {
                '??': [
                  {
                    '@.': '!workstream',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!degree_of_change',
              },
              'Low',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    lowGeneral: {
      filter: {
        and: [
          {
            in: [
              'General',
              {
                '??': [
                  {
                    '@.': '!workstream',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!degree_of_change',
              },
              'Low',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    lowGrants: {
      filter: {
        and: [
          {
            in: [
              'Grants',
              {
                '??': [
                  {
                    '@.': '!workstream',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!degree_of_change',
              },
              'Low',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    lowHcmCore: {
      filter: {
        and: [
          {
            in: [
              'HCM Core',
              {
                '??': [
                  {
                    '@.': '!workstream',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!degree_of_change',
              },
              'Low',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    lowIntegrations: {
      filter: {
        and: [
          {
            in: [
              'Integrations',
              {
                '??': [
                  {
                    '@.': '!workstream',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!degree_of_change',
              },
              'Low',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    lowInventoryManagement: {
      filter: {
        and: [
          {
            in: [
              'Inventory Management',
              {
                '??': [
                  {
                    '@.': '!workstream',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!degree_of_change',
              },
              'Low',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    lowLearning: {
      filter: {
        and: [
          {
            in: [
              'Learning',
              {
                '??': [
                  {
                    '@.': '!workstream',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!degree_of_change',
              },
              'Low',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    lowPayroll: {
      filter: {
        and: [
          {
            in: [
              'Payroll',
              {
                '??': [
                  {
                    '@.': '!workstream',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!degree_of_change',
              },
              'Low',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    lowPayrollAccounting: {
      filter: {
        and: [
          {
            in: [
              'Payroll Accounting',
              {
                '??': [
                  {
                    '@.': '!workstream',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!degree_of_change',
              },
              'Low',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    lowProcurement: {
      filter: {
        and: [
          {
            in: [
              'Procurement',
              {
                '??': [
                  {
                    '@.': '!workstream',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!degree_of_change',
              },
              'Low',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    lowRecruiting: {
      filter: {
        and: [
          {
            in: [
              'Recruiting',
              {
                '??': [
                  {
                    '@.': '!workstream',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!degree_of_change',
              },
              'Low',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    lowReporting: {
      filter: {
        and: [
          {
            in: [
              'Reporting',
              {
                '??': [
                  {
                    '@.': '!workstream',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!degree_of_change',
              },
              'Low',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    lowSupplierAccounts: {
      filter: {
        and: [
          {
            in: [
              'Supplier Accounts',
              {
                '??': [
                  {
                    '@.': '!workstream',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!degree_of_change',
              },
              'Low',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    lowTalent: {
      filter: {
        and: [
          {
            in: [
              'Talent',
              {
                '??': [
                  {
                    '@.': '!workstream',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!degree_of_change',
              },
              'Low',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    lowTimeTracking: {
      filter: {
        and: [
          {
            in: [
              'Time Tracking',
              {
                '??': [
                  {
                    '@.': '!workstream',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!degree_of_change',
              },
              'Low',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
  },
}
